export default "__VITE_ASSET__DVrT5zIc__"